'use strict';

(function (global) {

  // Путь к шаблону реквизита с типом "Ссылка на документ".
  const TEMPLATE = '/components/documentRequisite.compile.html';

  /**
   * Реквизит таблицы типа «Ссылка на документ».
   *
   * @since 5.5.0.1000
   * @class WebAccess.components.forms.requisites.DocumentSelect
   * @extends BaseObject
   * @param {string|WebAccess.components.forms.requisites.DocumentSelect.settings} id Идентификатор элемента. Является обязательным параметром
   * @param {string} [opt_toolTip] Всплывающая подсказка
   * @param {string} [opt_searchReqName] Наименование отображаемого реквизита

   * @property {string} id Идентификатор элемента
   * @property {string} toolTip Всплывающая подсказка
   * @property {string} searchReqName Наименование отображаемого реквизита
   * @property {string} html HTML-разметка элемента
   *
   * @fires render вызывается после того, как HTML-разметка собрана и готова к использованию.
   * @throws ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED - заданы не все обязательные параметры.
   * @example
   * var field = new WebAccess.components.forms.requisites.DocumentSelect("employe_select", "РАБ").render();
   *     WebAccess.current.sideBar.tabs.FldTree.setHtml(field);
   */

  /**
   * @typedef {object} WebAccess.components.forms.requisites.DocumentSelect.settings
   * @property {string} id Идентификатор формы справочника
   * @property {string} toolTip Всплывающая подсказка
   * @property {string} searchReqName Наименование отображаемого реквизита
   * @property {string} html HTML-разметка элемента
   */
  const DocumentSelect = BaseObject.extend({

    /**
     * Инициализация.
     *
     * @method WebAccess.components.forms.requisites.DocumentSelect#init
     * @param {string} id ИД реквизита.
     * @param {string} [toolTip=''] Текст подсказки.
     * @param {string} [searchReqName='ISBEDocName'] Имя реквизита, по которому осуществляется поиск.
     */
    init(id, toolTip = '', searchReqName = 'ISBEDocName') {
      this._super(id);
      this.className = 'DocumentSelect';

      if (!id) return;

      if ($.isPlainObject(id)) {
        $.extend(this, id);
      } else {
        this.id = id;
        this.toolTip = toolTip;
        this.searchReqName = searchReqName;
      }
    },

    /**
     * Генерирует HTML-разметку
     *
     * @method WebAccess.components.forms.requisites.DocumentSelect#render
     * @return {string} Сгенерированная HTML-разметка.
     */
    render() {
      let result = '';
      let requestMap = {
        'ID': this.id.toLowerCase(),
        'ToolTip': this.toolTip,
        'SearchReqName': this.searchReqName,
      };

      CallServiceSync('/Requisite.asmx/DocumentSelect', requestMap, (response) => {
        if (response.Success) {
          result = response.Result.html;
        }
        else {
          ShowMessage(response.Result);
        }
      });

      this.fire('render');
      this.html = result;
      return result;
    },

    /**
     * Асинхронно генерирует HTML-разметку
     *
     * @method WebAccess.components.forms.requisites.DocumentSelect#renderAsync
     * @param {object} data Модель для отрисовки реквизита.
     * @return {string} Сгенерированная HTML-разметка.
     */
    renderAsync(data) {
      //TODO: Этот метод использует hogan шаблон, а для его работы необходимо много данных,
      //в том числе частично нужны данные с серверной стороны. В будущем необходимо эти
      //данные научится формировать либо получать. Сейчас пока этот метод будет работать
      //только если предоствить все данные явно. В будущем метод render(тот что выше) нужно
      //будет переделать на него, но с флагами синхронного вызова.
      if (!data) {
        WA.raise('NOT_IMPLEMENTED_EXCEPTION');
      }

      let result = $.Deferred();

      WA.templates.render(TEMPLATE, data).done((html) => {
        this.html = html;
        result.resolve(this.html);
        this.fire('render');
      });

      return result;
    }
  });

  global.DocumentSelect = DocumentSelect;
})(window.WebAccess.components.forms.requisites);